const resource = 'filters'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  getServiceName: name => 'filterService',
})
